export const GET_ROLE_DEFINITIONS = "GET_ROLE_DEFINITIONS"
export const GET_ROLE_DEFINITIONS_SUCCESS = "GET_ROLE_DEFINITIONS_SUCCESS"

export const ADD_NEW_ROLE_DEFINITION = "ADD_NEW_ROLE_DEFINITION"
export const ADD_ROLE_DEFINITION_SUCCESS = "ADD_ROLE_DEFINITION_SUCCESS"

export const UPDATE_ROLE_DEFINITION = "UPDATE_ROLE_DEFINITION"
export const UPDATE_ROLE_DEFINITION_SUCCESS = "UPDATE_ROLE_DEFINITION_SUCCESS"

export const DELETE_ROLE_DEFINITION = "DELETE_ROLE_DEFINITION"
export const DELETE_ROLE_DEFINITION_SUCCESS = "DELETE_ROLE_DEFINITION_SUCCESS"

export const PAGE_OPERATION_LIST = "PAGE_OPERATION_LIST"
export const PAGE_OPERATION_LIST_SUCCESS = "PAGE_OPERATION_LIST_SUCCESS"

export const PAGE_OPERATION_LIST_FOR_VALUE = "PAGE_OPERATION_LIST_FOR_VALUE"
export const PAGE_OPERATION_LIST_FOR_VALUE_SUCCESS = "PAGE_OPERATION_LIST_FOR_VALUE_SUCCESS"

export const ROLE_DEFINITION_API_ERROR = "ROLE_DEFINITION_API_ERROR"

